"use strict";

// Production steps of ECMA-262, Edition 6, 22.1.2.1
if (!Array.from) {
 Array.from = (function () {
  var toStr = Object.prototype.toString;
  var isCallable = function (fn) {
   return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
  };
  var toInteger = function (value) {
   var number = Number(value);
   if (isNaN(number)) { return 0; }
   if (number === 0 || !isFinite(number)) { return number; }
   return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
  };
  var maxSafeInteger = Math.pow(2, 53) - 1;
  var toLength = function (value) {
   var len = toInteger(value);
   return Math.min(Math.max(len, 0), maxSafeInteger);
  };

  // The length property of the from method is 1.
  return function from(arrayLike/*, mapFn, thisArg */) {
   // 1. Let C be the this value.
   var C = this;

   // 2. Let items be ToObject(arrayLike).
   var items = Object(arrayLike);

   // 3. ReturnIfAbrupt(items).
   if (arrayLike == null) {
    throw new TypeError('Array.from requires an array-like object - not null or undefined');
   }

   // 4. If mapfn is undefined, then let mapping be false.
   var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
   var T;
   if (typeof mapFn !== 'undefined') {
    // 5. else
    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
    if (!isCallable(mapFn)) {
     throw new TypeError('Array.from: when provided, the second argument must be a function');
    }

    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
    if (arguments.length > 2) {
     T = arguments[2];
    }
   }

   // 10. Let lenValue be Get(items, "length").
   // 11. Let len be ToLength(lenValue).
   var len = toLength(items.length);

   // 13. If IsConstructor(C) is true, then
   // 13. a. Let A be the result of calling the [[Construct]] internal method
   // of C with an argument list containing the single item len.
   // 14. a. Else, Let A be ArrayCreate(len).
   var A = isCallable(C) ? Object(new C(len)) : new Array(len);

   // 16. Let k be 0.
   var k = 0;
   // 17. Repeat, while k < len… (also steps a - h)
   var kValue;
   while (k < len) {
    kValue = items[k];
    if (mapFn) {
     A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
    } else {
     A[k] = kValue;
    }
    k += 1;
   }
   // 18. Let putStatus be Put(A, "length", len, true).
   A.length = len;
   // 20. Return A.
   return A;
  };
 }());
}

document.querySelector('.header__navtoggler').addEventListener('click', () => {
 document.body.classList.toggle('body--activenav');
});

document.querySelector('.searchtoggler').addEventListener('click', () => {
 document.body.classList.toggle('body--activesearch');

 // Set focus
 if (document.body.classList.contains('body--activesearch')) {
  document.querySelector('header .search-query.input-medium').focus()
 }
});

// Subnav Behaviour

var parentMenuItemsNodelist = document.querySelectorAll('.headerbar__mainnavigation ul li.parent > a, .headerbar__mainnavigation ul li.parent > span');
var parentMenuItems = Array.from(parentMenuItemsNodelist); // Need to convert to Array


parentMenuItems.forEach(function(parentMenuItem) {

 parentMenuItem.addEventListener('click', function (e) {
  if (window.innerWidth < 1280) {
   var MenuItemSubnav = getSiblings(this); // child ul of clicked list-item
   var ParentMenuItemSiblings = getSiblings(this.parentNode); // siblings of click list-item

   if (this.classList.contains('clicked')) {
    e.preventDefault();
    this.classList.remove('clicked');
    MenuItemSubnav[0].classList.remove('expanded');
   } else {
    e.preventDefault();
    this.classList.add('clicked');
    MenuItemSubnav[0].classList.add('expanded');
   }

   ParentMenuItemSiblings.forEach(function (parentMenuItemSibling) {
    var parentSiblingMenus = parentMenuItemSibling.querySelectorAll('ul');
    var parentSiblingMenuItems = Array.from(parentSiblingMenus);

    parentSiblingMenuItems.forEach(function (parentSiblingMenuItem) {
     if (parentSiblingMenuItem.classList.contains('expanded')) {
      parentSiblingMenuItem.classList.remove('expanded');
     } else {
     }
    })
   })
  }
 });
});
var getSiblings = function (elem) {
 var siblings = [];
 var sibling = elem.parentNode.firstChild;
 for (; sibling; sibling = sibling.nextSibling) {
  if (sibling.nodeType !== 1 || sibling === elem) continue;
  siblings.push(sibling);
 }
 return siblings;
};

// Equalheight parent-menu-items dropdown 1280+

var equalParentHeight = function (parentListItem) {
 let subnavItems = parentListItem.querySelectorAll('ul > li.parent > a');

 let highestHeight = 0;

 for (let subnavItem of subnavItems) {
  if (subnavItem.clientHeight > highestHeight) {
   highestHeight = subnavItem.clientHeight;
  }
 }

 for (let subnavItem of subnavItems) {
  subnavItem.style.height = highestHeight + 'px';
 }
}



if(window.innerWidth >= 1280) {
 for (let parentMenuitem of document.querySelectorAll('.headerbar__mainnavigation > ul > li'))
  parentMenuitem.addEventListener('mouseenter', () => {
   equalParentHeight(parentMenuitem);
  });
}

// Contacttrigger Dozenten Teamliste

for (let contact of document.querySelectorAll('.category .category__contact')) {
 for (let image of contact.querySelectorAll('.category__contact__image')) {
  image.addEventListener('click', () => {
   contact.classList.toggle('open');
   if(contact.classList.contains('open')) {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Schließen -';
    }
   } else {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Mehr +';
    }
   }
  })
 }
 for (let title of contact.querySelectorAll('.category__contact__title')) {
  title.addEventListener('click', () => {
   contact.classList.toggle('open');
   if(contact.classList.contains('open')) {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Schließen -';
    }
   } else {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Mehr +';
    }
   }
  })
 }
 for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
  trigger.addEventListener('click', () => {
   contact.classList.toggle('open');
   if(contact.classList.contains('open')) {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Schließen -';
    }
   } else {
    for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
     trigger.innerText = 'Mehr +';
    }
   }
  })
 }
 contact.querySelector('.backgroundtoggler').addEventListener('click', () => {
  contact.classList.toggle('open');
  if(contact.classList.contains('open')) {
   for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
    trigger.innerText = 'Schließen -';
   }
  } else {
   for (let trigger of contact.querySelectorAll('.category__contact__addtionalinformationtrigger')) {
    trigger.innerText = 'Mehr +';
   }
  }
 });
}


// Contacttrigger Dozenten Instrumentdetail

let instrumentdetailTeacherClicked = (e) => {
 e.preventDefault();

 let teacherId = e.target.getAttribute('data-teacherid');
 const contact = document.querySelector('.unterrichtsangebot__teachers__teacher[data-teacherid="' + teacherId + '"]')

 if(contact.classList.contains('open')) {
  contact.classList.toggle('open');

  for (let trigger of contact.querySelectorAll('.teacher__addtionalinformationtrigger')) {
   trigger.innerText = 'Mehr +';
  }
 } else {
  // Fetch contact data
  var request = new XMLHttpRequest();
  request.open('GET', Joomla.getOptions('system.paths').base + '/index.php?option=com_ajax&module=dozent&method=getDozent&format=json&dozentId=' + teacherId, true);

  request.onload = function() {
   if (this.status >= 200 && this.status < 400) {
    // Success!
    contact.classList.toggle('open');

    // Let's set the markup
    contact.querySelector('.teacher__detailcontent').innerHTML = JSON.parse(this.response).data.markup;
    contact.querySelector('.teacher__detailcontent .teacher__addtionalinformationtrigger').addEventListener('click', instrumentdetailTeacherClicked)

    for (let trigger of contact.querySelectorAll('.teacher__addtionalinformationtrigger')) {
     trigger.innerText = 'Schließen -';
    }
   } else {
    alert("Fehler")
   }
  };

  request.send();
 }
}

for (let contact of document.querySelectorAll('.unterrichtsangebot__teachers .unterrichtsangebot__teachers__teacher')) {
 contact.querySelector('.teacher__addtionalinformationtrigger').addEventListener('click', instrumentdetailTeacherClicked)
 contact.querySelector('.backgroundtoggler').addEventListener('click', instrumentdetailTeacherClicked)
 contact.querySelector('.teacher__content > h4').addEventListener('click', instrumentdetailTeacherClicked)
 contact.querySelector('img').addEventListener('click', instrumentdetailTeacherClicked)
}

// Accordion

if (document.querySelector('.accordion')) {
 for (let accordion of document.querySelectorAll('.accordion')) {
  for (let item of accordion.querySelectorAll('.accordion__item')) {
   item.querySelector('.accordion__item__toggle').addEventListener('click', () => {
    item.classList.toggle('active');
   })
  }
 }
}

// To Top Button

document.querySelector('.footer__bar__totop').addEventListener('click', () => {
 document.body.scrollTop = 0; // For Safari
 document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
})

// Overview area

for (let overviewArea of document.querySelectorAll('.overview')) {
 for (let area of overviewArea.querySelectorAll('.overview__area')) {
  area.addEventListener('mouseenter', () => {
   switch (true) {
    case area.classList.contains('orange'):
     overviewArea.classList.add('bg--orange');
     break;

    case area.classList.contains('turkis'):
     overviewArea.classList.add('bg--turkis');
     break;

    case area.classList.contains('green'):
     overviewArea.classList.add('bg--green');
     break;

    case area.classList.contains('yellow'):
     overviewArea.classList.add('bg--yellow');
     break;
   }
  });
  area.addEventListener('mouseleave', () => {
   switch (true) {
    case overviewArea.classList.contains('bg--orange'):
     overviewArea.classList.remove('bg--orange');
     break;

    case overviewArea.classList.contains('bg--turkis'):
     overviewArea.classList.remove('bg--turkis');
     break;

    case overviewArea.classList.contains('bg--green'):
     overviewArea.classList.remove('bg--green');
     break;

    case overviewArea.classList.contains('bg--yellow'):
     overviewArea.classList.remove('bg--yellow');
     break;
   }
  })
 }
}

function toggleFloatbutton() {
 if (document.querySelector('.float')) {
   if (document.documentElement.scrollTop > 300) {
    document.querySelector('.float').style.opacity = 1;
   } else {
    document.querySelector('.float').style.opacity = 0;
   }
 }
}

document.addEventListener('scroll', toggleFloatbutton);

window.addEventListener('resize', () => {
 if (window.innerWidth > 1065) {
  document.querySelector('body').classList.remove('body--activenav')
 }
})
